import { addComplaintRequest, IAddComplaintOptions } from '../../api/complaint';
import { IThunkActionCreator } from '../index';
import { setComplaintId, setCanUserSeeFeedbackForm } from './feedback_complaint';

export type TAddComplaintActions = IAddComplaintRequested | IAddComplaintRequestFinished | IAddComplaintRequestFailed;

interface IAddComplaintRequested {
  type: 'IAddComplaintRequested';
}

interface IAddComplaintRequestFinished {
  type: 'IAddComplaintRequestFinished';
  getUserFeedback: boolean;
}

interface IAddComplaintRequestFailed {
  errorMessage: string;
  type: 'IAddComplaintRequestFailed';
}

export function addComplaint(options: IAddComplaintOptions): IThunkActionCreator {
  // @ts-ignore
  return async (dispatch, getState, context) => {
    dispatch<IAddComplaintRequested>({
      type: 'IAddComplaintRequested',
    });

    /* istanbul ignore next */
    const moderationComplaintsBrowserUrl = context.config.get('moderationComplaints.browserUrl') as string;
    if (!moderationComplaintsBrowserUrl) {
      throw new Error(`'moderationComplaints.browserUrl' is not configured`);
    }

    try {
      const response = await addComplaintRequest(context.makeRequest, moderationComplaintsBrowserUrl, options);

      if (response.complaintId) {
        dispatch(setComplaintId(Number(response.complaintId)));
      }

      dispatch<IAddComplaintRequestFinished>(setCanUserSeeFeedbackForm(response.getUserFeedback));

      return response;
    } catch (error) {
      dispatch<IAddComplaintRequestFailed>({
        errorMessage: 'Не удалось отправить жалобу. Проверьте своё интернет соединение и попробуйте еще раз.',
        type: 'IAddComplaintRequestFailed',
      });
      throw new Error(error);
    }
  };
}
